import PrivateLayout from "@/components/layouts/private-layout";
import PaymentsPage from "@/pages/payments";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/payments/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PrivateLayout>
      <PaymentsPage />
    </PrivateLayout>
  );
}
